<p-button
  [outlined]="true"
  label="Export"
  icon="pi pi-download"
  (onClick)="downloadList()"
  [loading]="loading"
  pTooltip="Download companies as Excel"
  tooltipPosition="bottom"
/>
